import { createSelector } from 'reselect'

const onbardingGuideCardsSelector = state => state.onboardingGuide.cards

export default type => createSelector(
	[onbardingGuideCardsSelector],
	cards => cards.find(card => card.type === type) || {}
)
